var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-collapse',{attrs:{"visible":""}},[_c('b-card',[_c('VehicleActions',{attrs:{"label":_vm.selectedVehicle}})],1)],1),_c('div',[_c('EventTable',{on:{"eventSelected":_vm.onEventSelected}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }